import React from "react";
import { Truck, ShieldCheck, Wallet, BadgeCheck, Star, PackageCheck } from "lucide-react";
import { SHOP } from "@/constants/testIds";

const items = [
  { id: "tb-60min", icon: Truck, title: "Fastest Delivery", sub: "Across major cities" },
  { id: "tb-min", icon: PackageCheck, title: "No Min Order", sub: "Buy 1 piece, we deliver" },
  { id: "tb-cod", icon: Wallet, title: "Pay on Delivery", sub: "Cash, UPI, Card" },
  { id: "tb-qa", icon: ShieldCheck, title: "Quality Assurance", sub: "100% genuine brands" },
  { id: "tb-replace", icon: BadgeCheck, title: "7-Day Replacement", sub: "No-questions return" },
  { id: "tb-rating", icon: Star, title: "Rated 4.9 on Google", sub: "Trusted by 50k+ customers" },
];

export default function TrustBadges() {
  return (
    <section data-testid={SHOP.trustBadges} className="mt-14 sm:mt-20 bg-gray-50 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-5 sm:gap-6">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <div key={it.id} className="flex flex-col items-start gap-2.5">
                <div className="w-11 h-11 rounded-lg bg-white border border-gray-200 grid place-items-center text-[#0056D2] shadow-sm">
                  <Icon size={20} strokeWidth={2.4} />
                </div>
                <div>
                  <div className="text-sm font-extrabold text-gray-900">{it.title}</div>
                  <div className="text-xs text-gray-600 mt-0.5">{it.sub}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
